import { render, staticRenderFns } from "./Vumatel.vue?vue&type=template&id=e93eb080&scoped=true&"
import script from "./Vumatel.vue?vue&type=script&lang=js&"
export * from "./Vumatel.vue?vue&type=script&lang=js&"
import style0 from "./Vumatel.vue?vue&type=style&index=0&id=e93eb080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93eb080",
  null
  
)

export default component.exports